module.exports = __webpack_public_path__ + "static/media/bell.1c8267e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bell.gif
// module id = 245
// module chunks = 0